import type { paths } from '../../types/clients/game-configuration'
import { useOpenapi } from '#imports'

/**
 * @title useGameConfigurationClient
 * @see Docs https://game-configuration-prod.spilnu.dk/docs?api-docs.json
 */
export const useGameConfigurationClient = () => {
    const client = useOpenapi<paths>({
        baseUrl: '/gateway/game-configuration',
        service: 'gameConfiguration'
    })

    return {
        client
    }
}
